// Used to get roles of user. Data after '=' only a-z|0-9
export enum EActionsType {
	edit = 'edit',
	list = 'list',
	visualize = 'visualize',
	create = 'create'
}